import { EnumSincronizacaoGeral } from 'model/enums/enum-sincronizacao-geral';
import { KeyValueModel } from "model";

export const TpSincronizacaoGeralMock: KeyValueModel[] = [
    new KeyValueModel(EnumSincronizacaoGeral.SessaoValores, "Sessões Valores"),
    new KeyValueModel(EnumSincronizacaoGeral.Vendas, "Vendas"),

];
